import type { ThemeClasses } from "../../types/components";
import { CRUDTooltip } from "./CRUDTooltip";

export default function Modal({
    content,
    themeClasses,
    onClose,
    title = "Ejemplo de titulo",
    buttonAction,
    showEditButton = false,
    onEdit,
    width,
    disableCRUD = false,
}: {
    content: React.ReactNode;
    themeClasses: ThemeClasses;
    onClose: () => void;
    title: string;
    buttonAction?: React.ReactNode;
    showEditButton?: boolean;
    onEdit?: () => void;
    width?: string;
    disableCRUD?: boolean;
}) {
    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div
                className={`${themeClasses.bg} rounded-lg ${width ? width : 'max-w-2xl'} max-h-[95vh] overflow-y-auto overflow-x-hidden border ${themeClasses.border} shadow-2xl`}
            >
                <div className="p-6 py-2 border-gray-200 dark:border-gray-700">
                    <div className="flex items-center justify-between py-2">
                        <h2 className={`font-bold ${themeClasses.text}`}>{title}</h2>
                        <div className="flex items-center space-x-2">
                            {/* Botón de editar condicional */}
                            {showEditButton && (
                                <CRUDTooltip>
                                    <button
                                        onClick={onEdit}
                                        disabled={disableCRUD}
                                        className="bg-primary-500 hover:bg-primary-400 px-4 py-2 rounded-lg text-sm flex items-center space-x-2 transition-colors whitespace-nowrap"
                                    >
                                        {/* <i className="ri-edit-line"></i> */}
                                        <span>Editar</span>
                                    </button>
                                </CRUDTooltip>
                            )}

                            {buttonAction && buttonAction}
                            <button
                                onClick={onClose}
                                className={`p-2 ${themeClasses.buttonHover} rounded-lg transition-colors`}
                            >
                                <i className={`ri-close-line text-xl ${themeClasses.text}`}></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="p-6 pt-2 overflow-y-auto">{content}</div>
            </div>
        </div>
    );
}
